// extracted by mini-css-extract-plugin
export default {"btn":"TitleTabsButton_btn__PJzTa","active":"TitleTabsButton_active__MXp3I"};